import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { ENVIRONMENT } from '@us/app-config';
import { RouterUtil } from '@us/web/shared/utils';
import { CartComponent } from './components/cart/cart.component';
import { CartCheckoutPage } from './pages/cart-checkout/cart-checkout.page';
import { CartPage } from './pages/cart/cart.page';

export const routes: Routes = [
    {
        path: '',
        canMatch: [() => inject(ENVIRONMENT).appType === 'fnb'],
        component: CartPage
    },
    {
        path: '',
        canMatch: [() => inject(ENVIRONMENT).appType === 'retail'],
        component: CartComponent
    },
    {
        path: RouterUtil.Cog.Detail,
        component: CartPage
    },
    {
        path: RouterUtil.Cog.Status,
        component: CartPage
    },
    {
        path: RouterUtil.Cog.Checkout,
        component: CartCheckoutPage
    }
];
